/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Logger } from '@opentelemetry/api-logs';
import { Resource } from '@opentelemetry/resources';
import { LogRecordProcessor } from '../LogRecordProcessor';
import { LogRecordLimits } from '../types';
import { NoopLogRecordProcessor } from '../export/NoopLogRecordProcessor';
import { MultiLogRecordProcessor } from '../MultiLogRecordProcessor';

export class LoggerProviderSharedState {
  readonly loggers: Map<string, Logger> = new Map();
  activeProcessor: LogRecordProcessor;
  readonly registeredLogRecordProcessors: LogRecordProcessor[] = [];

  constructor(
    readonly resource: Resource,
    readonly forceFlushTimeoutMillis: number,
    readonly logRecordLimits: Required<LogRecordLimits>,
    readonly processors: LogRecordProcessor[]
  ) {
    if (processors.length > 0) {
      this.registeredLogRecordProcessors = processors;
      this.activeProcessor = new MultiLogRecordProcessor(
        this.registeredLogRecordProcessors,
        this.forceFlushTimeoutMillis
      );
    } else {
      this.activeProcessor = new NoopLogRecordProcessor();
    }
  }
}
